import styled from '@emotion/styled';

const Wrapper = styled.div`
  ol {
    margin: 0 0 0 1rem;
    padding: 0;
  }
  table {
    td {
      padding: 1rem;
      border: 0;
      line-height: 1.2;
      text-transform: uppercase;
      white-space: break-spaces;
      &:first-of-type {
        text-align: right;
      }
    }
    div {
      display: flex;
      align-items: center;
      gap: .5rem;
    }
    strong {
      font-size: 4rem;
      line-height: 1;
      color: ${(props) => props.theme.mainColors.primary};
    }
  }

  & > :last-child {
    margin-bottom: 0;
  }
`;

const ChartItem = styled.div`
  margin-bottom: 2rem;
`;

const ChartItemTitle = styled.b`
  font-weight: 700;
`;

export {
  Wrapper,
  ChartItem,
  ChartItemTitle
};
